import Header from '@/components/Header';
import Hero from '@/components/Hero';
import EditorialMarquee from '@/components/EditorialMarquee';
import LegalManifesto from '@/components/LegalManifesto';
import Services from '@/components/Services';
import Gallery from '@/components/Gallery';
import BusinessHours from '@/components/BusinessHours';
import Booking from '@/components/Booking';
import ContactForm from '@/components/ContactForm';
import Footer from '@/components/Footer';

export default function Home() {
  return (
    <div className="bg-ink-950 min-h-screen">
      <Header />
      <main>
        <Hero />
        <EditorialMarquee />
        <LegalManifesto />
        <Services />
        <Gallery />
        <BusinessHours />
        <Booking />
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
}
